import TreatmentPage from "./TreatmentPage";

export default function SkinTagMoleWartRemoval() {
  return (
    <TreatmentPage
      title="Skin Tag, Birthmark, Mole & Wart Removal"
      heroImage="/Treatment/mole-removal-drtruptis-clinic.jpg"

      intro="Skin tags, moles, birthmarks, and warts are common skin growths that can appear on different parts of the body. While most of them are harmless, they may cause discomfort, cosmetic concerns, or irritation. Modern dermatological treatments allow safe and effective removal with minimal discomfort."

      description="These skin conditions can develop due to genetic factors, viral infections, sun exposure, or skin friction. Professional removal treatments help eliminate unwanted skin growths and restore smooth, healthy-looking skin."

      howItWorks="After a proper skin examination, the dermatologist selects the most suitable removal method such as laser treatment, radiofrequency (RF), electrocautery, or minor surgical procedures. These methods precisely remove the growth while protecting the surrounding skin, ensuring safe and effective results."

      benefits={[
        "Safe and quick removal of skin tags, moles, and warts.",
        "Improves skin appearance and confidence.",
        "Minimally invasive procedure.",
        "Reduces irritation and discomfort caused by skin growths.",
        "Little to no downtime.",
        "Prevents further spreading in case of warts."
      ]}

      beforeAfterImages={[
        "/Treatment/before-mole-removal-drtrupti-clinic.jpeg",
        "/Treatment/before-mole-removal-drtrupti-clinic.jpeg",
      ]}

      faqs={[
        { q: "Is the removal procedure painful?", a: "The procedure is usually done with local anesthesia, so patients feel minimal discomfort." },
        { q: "Will the growth come back after removal?", a: "Most removed skin tags, moles, or warts do not return, but new ones can develop over time." },
        { q: "Is there any downtime?", a: "There is minimal downtime, and most patients can resume normal activities the same day." },
        { q: "Is the procedure safe?", a: "Yes, when performed by a qualified dermatologist, it is a safe and effective treatment." }
      ]}
    />
  );
}